import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styles: []
})
export class LandingComponent implements OnInit {
  root:string = "";
  cotizadores:any=null;
  embed:string = "";
  embedName:string = "";

  constructor(
    private api:ApiService
  ) { 
    this.root = environment.root;
    this.api.getCotizadores().subscribe(x=>{
      this.cotizadores = x.data;
    });
  }

  ngOnInit() {
  }

  setEmbed(cotizador:any){
    let ret = "<iframe src='" + cotizador.path + "' frameborder='0' width='100%' height='100%'></iframe>";
    this.embed = ret;
    this.embedName = cotizador.nombre;
  }
}
